import * as React from 'react';
import { Field } from 'formik';
import PageFooter from '../../Helpers/PageFooter';
import {
  WizardSubmitButton,
  WizardPreviousButton
} from 'buyside/components/presentation/Form/Wizard/Wizard';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import CityAutocomplete from 'buyside/components/presentation/CityAutocomplete/cityAutocomplete';
import PageHeader from '../../Helpers/pageHeader';
import { AllFormikProps } from 'interfaces/userApplication/userApplication';
import RecaptchaFailed from '../../Helpers/RecaptchaFailed';

import styles from '../pageStyles.scss';

type PickedFormikProps = Pick<AllFormikProps, 'setFieldValue' | 'initialValues'>;

interface InformationProps extends PickedFormikProps {
  checkIfEmailExists: (value: string) => void;
  isLoading: boolean;
  isRobot: boolean;
}

export const Information: React.FunctionComponent<InformationProps> = ({
  setFieldValue,
  checkIfEmailExists,
  isLoading,
  isRobot,
  initialValues
}): React.ReactElement => {
  return (
    <>
      <PageHeader subHeader="Tell us about yourself" />
      <div className={styles.inputForm}>
        <div className={styles.inputFieldHalf}>
          <Field
            analyticsTag="application-first-name"
            component={InputField}
            label="First Name"
            name="firstName"
          />
        </div>
        <div className={styles.inputFieldHalf}>
          <Field
            analyticsTag="application-last-name"
            component={InputField}
            label="Last Name"
            name="lastName"
          />
        </div>
        <div className={styles.inputFieldHalf}>
          <Field
            analyticsTag="application-email-address"
            component={InputField}
            label="Email Address"
            name="email"
            validate={checkIfEmailExists}
            disabled={initialValues?.email}
          />
        </div>
        <div className={styles.inputFieldHalf}>
          <Field
            analyticsTag="application-linkedin"
            component={InputField}
            label="LinkedIn Profile"
            name="linkedinUrl"
          />
        </div>
        <div className={styles.inputFieldHalf}>
          <CityAutocomplete
            analyticsTag="application-city"
            icon={false}
            name="city"
            placeholder="Begin Typing..."
            setFieldValue={setFieldValue}
          />
        </div>
        <div className={styles.inputFieldHalf}>
          <Field
            analyticsTag="application-phone-number"
            component={InputField}
            label="Phone Number (optional)"
            name="phone"
          />
        </div>
      </div>
      <WizardPreviousButton />
      <WizardSubmitButton
        submitText="Continue"
        analyticsTag="application-continue-information"
        isLoading={isLoading}
      />
      {isRobot && <RecaptchaFailed />}
      <PageFooter />
    </>
  );
};

export default Information;
